module.exports = __webpack_public_path__ + "img/logo-nova.4db21375.gif";